import { GTM } from '../../../../services/analytics/tags/gtm'
import { GtmEvent } from '../../../../services/common/events/gtm'
import { AnalyticsEvent, IGTMControlFields } from '../../event'
import { GlobalDataFormatter } from '../global-data'

export class GtmProvider extends AnalyticsEvent {

    private data: any

    public constructor(data: any, type: string, value: string, action: string, element?: Element) {
        super(type, value, action, element)
        this.data = data
    }

    /**
     * Handle event
     */
    public handle(): void {

        /**
         * Event Handler: updates the attributes list and sends it to mParticle
         * @var data will be different for each event
         *
         */

        const gtm = new GTM()

        let eventData: any = { ...this.data }  // extra data common to all providers

        const dataAttrs = this.getProviderAttributesList('gtm')
        // Get Data Values ( this.metaProperties this is data coming from page-data )
        const globalFormatter = new GlobalDataFormatter(this.metaProperties)
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr)
                if(attrValue !== '') {
                    eventData[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error in class GtmProvider', e)
            }
        })

        const customData = this.getProviderCustomData()

        eventData = {
            ...eventData,
            ...customData
        }

        const gtmData: IGTMControlFields = this.getProviderControlField('gtm')

        if (this.action === 'page-load') {
            dispatchEvent(new CustomEvent(GtmEvent.FIRE_PAGE_VIEW, {
                    detail: eventData
            }))
        } else if (gtmData.gtm_event_type) {
            const eventDataWithAttributes = {
                ...eventData,
                event_type: gtmData.gtm_event_type || 'default'
            }
            // send gtm event with attributes
            gtm.sendEvent(eventDataWithAttributes)
        }
    }
}
